import styled from "styled-components";
import { IconButton, CircularProgress } from "@material-ui/core";
import { Close } from "@material-ui/icons";

export const ModalOverlay = styled.main`
  background: rgba(1, 1, 1, 0.6);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
`;

export const ModalContainer = styled.div`
  background: var(--white);
  width: 100%;
  height: 50vh;
  max-width: 480px;
  border-radius: 4px;
  box-shadow: 0 0 60px rgba(0, 0, 0, 0.05);
  text-align: center;
  position: relative;

  display: flex;
  flex-direction: column;
`;

export const ModalHeader = styled.header`
  background-color: #3d9be9;
  width: 100%;
  height: 64px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1rem;
`;

export const ModalTitle = styled.h6`
  font-size: 1.15rem;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 500;
  line-height: 1.6;
  letter-spacing: 0.0075em;
  color: #fff;
`;

export const CloseButton = styled(IconButton).attrs({
  edge: "end",
  color: "inherit",
})``;

export const CloseIcon = styled(Close).attrs({
  style: { fill: "white" },
})``;

export const UsersList = styled.div`
  width: 100%;
  height: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: auto;
`;

export const UserCard = styled.div`
  cursor: pointer;

  &:hover {
    background-color: #ededed;
  }
`;

export const UserName = styled.p`
  font-size: 15px;
  padding-top: 14px;
  width: 200px;
  height: 52px;
`;

export const Confirmation = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ConfirmationMessage = styled.p`
  font-size: 16px;
  width: 70%;
`;

export const ConfirmationOptions = styled.div`
  margin-top: 18px;
  width: 60%;
  display: flex;
  justify-content: space-between;
`;

export const Loading = styled(CircularProgress).attrs({
  size: 32,
})`
  color: white;
`;

export const YesButton = styled.button`
  height: 42px;
  width: 120px;
  border: 0;
  border-radius: 3px;
  background: #50b981;

  text-transform: uppercase;
  font-size: 13px;
  color: #ffff;
  cursor: pointer;
`;

export const NoButton = styled.button`
  height: 42px;
  width: 120px;
  border: 0;
  border-radius: 3px;
  background: #ef6573;

  text-transform: uppercase;
  font-size: 13px;
  color: #ffff;
  cursor: pointer;

  &:disabled {
    background: #ef65738d;
  }
`;
